import styled from 'styled-components'
import mediaQueries from 'components/media-queries'

export const DatePickersContainer = styled.div`
  position: relative;
  width: ${({ width }) => width && width};
`

export const OpenDateResponsivePickerOnly = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -10;

  ${mediaQueries.mobile`
    z-index: 10;
  `};
`

export const ImageLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;

  img {
    width: 100%;
  }
`

export const ButtonCloseContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  top: 35px;
  right: 20px;
  z-index: 20;
`

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
`

export const ModalContent = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  height: 100vh;
  width: 100vw;
  z-index: 10;
  overflow: auto;
  position: relative;
`

export const ModalHeader = styled.div`
  display: flex;
  padding: 35px 15px 15px 15px;
`

export const ImageLogoContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`

export const TitleIconContainer = styled.div`
  padding: 20px 15px 10px 15px;
`

export const TitleText = styled.div`
  text-align: left;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.blue};
`

export const ModalDatePickerContainer = styled.div``
